@if (loading()) {
<div class="spinner-container">
  <mat-spinner />
</div>
}